let dandbPromise = null;

export function loadOscilarScript(scriptUrl) {
  if (typeof window === 'undefined') return Promise.reject('Not in a browser');
  if (!scriptUrl) return Promise.reject('Missing script URL');

  if (window.__ojsdk__) return Promise.resolve(window.__ojsdk__);

  if (dandbPromise) return dandbPromise;

  dandbPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.defer = true;

    script.onload = () => {
      // Poll for up to 3 seconds for window.__ojsdk__ to appear
      const maxAttempts = 30;
      let attempts = 0;

      const checkReady = () => {
        if (window.__ojsdk__) {
          resolve(window.__ojsdk__);
        } else if (attempts < maxAttempts) {
          attempts += 1;
          setTimeout(checkReady, 100);
        } else {
          reject('DAndB loaded, but did not expose itself on window');
        }
      };

      checkReady();
    };

    script.onerror = () => reject('Failed to load DAndB script');

    document.body.appendChild(script);
  });

  return dandbPromise;
}
